<template>
  <div>
    <div style="background-color: light-gray" v-if="showToggler">
      <a @click.prevent="toggleFilter()" href="#">{{
        translationHelper.getTranslation("wbk_Filter")
      }}</a>
    </div>
    <div
      style="background-color: light-gray; border: 1px solid black"
      class="filter-content scfForm"
      v-if="showFilters"
    >
      <div class="searchbox">
        <div class="">
          <label
            >{{ translationHelper.getTranslation("wbk_Filter_Type")
            }}<select v-model="filter.typeFilter">
              <option value="all">
                {{ translationHelper.getTranslation("wbk_Filter_Type_All") }}
              </option>
              <option v-for="option in types" :value="option">
                {{ option }}
              </option>
            </select></label
          >
        </div>
      </div>
      <div class="searchbox">
        <span class="scfCheckbox">
          <div
            class="icheckbox_hslu icheck-item"
            :class="{ checked: filter.useDepartmentFilter }"
            @click="filter.useDepartmentFilter = !filter.useDepartmentFilter"
          >
            <input
              ref="cbxuseDepartmentFilters"
              class="icheck-input"
              type="checkbox"
              key="chkuseDepartmentFilter"
              id="chkuseDepartmentFilter"
              v-model="filter.useDepartmentFilter"
            />
          </div>
          <label class="icheck-label" for="chkuseDepartmentFilter">{{
            translationHelper.getTranslation("wbk_Filter_Department")
          }}</label></span
        >
        <select
          v-if="filter.useDepartmentFilter"
          :disabled="!filter.useDepartmentFilter"
          size="8"
          v-model="filter.departmentFilter"
          multiple
        >
          <option v-for="department in departments" :value="department">
            {{ department }}
          </option>
        </select>
      </div>

      <div class="searchbox">
        <label
          >{{ translationHelper.getTranslation("wbk_Filter_Title") }}
          <input v-model="filter.searchTitle" />
        </label>
      </div>
      <div class="searchbox">
        <label
          >{{ translationHelper.getTranslation("wbk_Filter_Description") }}

          <input v-model="filter.searchDescription" />
        </label>
      </div>
      <div class="searchbox">
        <div class="">
          <span class="scfCheckbox">
            <div
              class="icheckbox_hslu icheck-item"
              :class="{ checked: filter.zeroDuration }"
              @click="filter.zeroDuration = !filter.zeroDuration"
            >
              <input
                ref="cbxBusinessAddress"
                class="icheck-input"
                type="checkbox"
                key="chkDuration"
                id="chkDuration"
                v-model="filter.zeroDuration"
                @change="executeFilter"
              />
            </div>
            <label class="icheck-label" for="chkDuration">{{
              translationHelper.getTranslation("wbk_Filter_ZeroDuration")
            }}</label>
          </span>
        </div>
      </div>
      <div class="searchbox">
        <div class="">
          <span class="scfCheckbox">
            <div
              class="icheckbox_hslu icheck-item"
              :class="{ checked: filter.searchEmpty }"
              @click="chkSearchEmptyChange"
            >
              <input
                ref="cbxBusinessAddress"
                class="icheck-input"
                type="checkbox"
                key="chkEmpty"
                id="chkEmpty"
                v-model="filter.searchEmpty"
                @change="executeFilter"
              />
            </div>
            <label class="icheck-label" for="chkEmpty">{{
              translationHelper.getTranslation("wbk_Filter_EmptyDescription")
            }}</label>
          </span>
        </div>
      </div>
      <div class="searchbox">
        <div class="">
          <span class="scfCheckbox">
            <div
              class="icheckbox_hslu icheck-item"
              :class="{ checked: filter.useContentLongerThan }"
              @click="chkUseContentLongerThanChange"
            >
              <input
                class="icheck-input"
                type="checkbox"
                key="chkUseContentLongerThan"
                id="chkUseContentLongerThan"
                v-model="filter.useContentLongerThan"
              />
            </div>
            <label class="icheck-label" for="chkUseContentLongerThan"
              >{{
                translationHelper.getTranslation("wbk_Filter_ContentLength")
              }}&nbsp;</label
            ><input v-model="filter.contentMinLength" /><label
              >&nbsp;{{
                translationHelper.getTranslation(
                  "wbk_Filter_ContentLength_Chars"
                )
              }}</label
            >
          </span>
        </div>
      </div>
      <div class="searchbox">
        <div class="">
          <span class="scfCheckbox">
            <div
              class="icheckbox_hslu icheck-item"
              :class="{ checked: filter.usePriceLongerThan }"
              @click="filter.usePriceLongerThan = !filter.usePriceLongerThan"
            >
              <input
                class="icheck-input"
                type="checkbox"
                key="chkUsePriceLongerThan"
                id="chkUsePriceLongerThan"
                v-model="filter.usePriceLongerThan"
              />
            </div>
            <label class="icheck-label" for="chkUsePriceLongerThan"
              >{{
                translationHelper.getTranslation("wbk_Filter_PriceLength")
              }}&nbsp;</label
            ><input v-model="filter.priceMinLength" /><label
              >&nbsp;{{
                translationHelper.getTranslation("wbk_Filter_PriceLength_Chars")
              }}</label
            >
          </span>
        </div>
      </div>
      <div>
        <button @click.prevent="executeFilter">
          {{
            translationHelper.getTranslation("wbk_Filter_Btn_Execute")
          }}</button
        >&nbsp;<button @click.prevent="resetFilter">
          {{ translationHelper.getTranslation("wbk_Filter_Btn_Reset") }}
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    showToggler: {
      type: Boolean,
      default: true,
      required: true,
    },
    showFilters: {
      type: Boolean,
      default: true,
      required: true,
    },
    translationHelper: {
      type: Object,
    },
    originalCourses: {
      type: Array,
      default: () => [],
    },
    originalParents: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      showFilter: true,
      filter: {
        typeFilter: "all",
        useDepartmentFilter: false,
        departmentFilter: [],
        searchTitle: "",
        searchDescription: "",
        searchEmpty: false,
        zeroDuration: false,
        contentMinLength: 140,
        useContentLongerThan: false,
        usePriceLongerThan: false,
        priceMinLength: 15,
      },
      defaultFilter: {
        typeFilter: "all",
        useDepartmentFilter: false,
        departmentFilter: [],
        searchTitle: "",
        searchDescription: "",
        searchEmpty: false,
        zeroDuration: false,
        contentMinLength: 140,
        useContentLongerThan: false,
        usePriceLongerThan: false,
        priceMinLength: 15,
      },
      types: [],
      departments: [],
      typesLookup:{},
      departmentsLookup:{}
    };
  },
  watch: {
    originalParents(newValue){
      var types = [];
      var departments = [];
      if (newValue && newValue.length > 0) {
        this.originalParents.forEach((course) => {
          var typeName = course.type;
          if (!(typeName in this.typesLookup)) {
            this.typesLookup[typeName] = 1;
            types.push(typeName);
          }
          course.departments.forEach((department) => {
            if (!(department in this.departmentsLookup)) {
              this.departmentsLookup[department] = 1;
              departments.push(department);
            }
          });
        });
        this.departments = this.departments.concat(departments);
        this.types = this.types.concat(types);
      }
    },
    originalCourses(newValue) {
      if (newValue && newValue.length > 0) {
        var types = [];
        var departments = [];
        this.originalCourses.forEach((course) => {
          var typeName = course.type;
          if (!(typeName in this.typesLookup)) {
            this.typesLookup[typeName] = 1;
            types.push(typeName);
          }
          course.departments.forEach((department) => {
            if (!(department in this.departmentsLookup)) {
              this.departmentsLookup[department] = 1;
              departments.push(department);
            }
          });
        });
        this.departments = this.departments.concat(departments);
        this.types = this.types.concat(types);
      }
    },
  },
  created(){
    this.$on("reset-filter", this.resetFilter);
  },
  methods: {
    toggleFilter() {
      this.showFilter = !this.showFilter;
      this.$emit("toggle-show-filter", this.showFilter);
    },
    resetFilter() {
      this.filter = this.defaultFilter;
      this.executeFilter();
    },
    executeFilter() {
      var filteredCourses = [];
      var filteredParents = [];
      filteredCourses = this.originalCourses.filter((course) => this.filterAll(course));
      filteredParents = this.originalParents.filter((course) => this.filterAll(course));
      this.$emit("filter-executed", filteredCourses, filteredParents);
    },
    filterAll(course){
        const getAllTypes = this.filter.typeFilter === "all";
        const useDepartmentFilter =
        this.filter.useDepartmentFilter &&
        this.filter.departmentFilter.length > 0;

        let retval = true;

        if (!getAllTypes) {
          retval = course.type === this.filter.typeFilter;
          if (!retval) return false;
        }

        if (useDepartmentFilter) {
          for (let i = 0; i < this.filter.departmentFilter.length; i++) {
            retval =
              course.departments.indexOf(this.filter.departmentFilter[i]) > -1;
            if (retval) {
              break;
            }
          }
          if (!retval) return false;
        }

        if (this.filter.searchTitle.length > 0) {
          retval =
            course.siteTitle
              .toLowerCase()
              .indexOf(this.filter.searchTitle.toLowerCase()) !== -1;
          if (!retval) return false;
        }

        if (this.filter.searchDescription.length > 0) {
          retval =
            course.siteHeadlineHtml
              .toLowerCase()
              .indexOf(this.filter.searchDescription.toLowerCase()) !== -1;
          if (!retval) return false;
        }

        if (this.filter.searchEmpty) {
          retval = course.siteHeadlineHtml.length === 0;
          if (!retval) return false;
        }

        if (this.filter.zeroDuration) {
          retval = course.duration === 0;
          if (!retval) return false;
        }

        if (this.filter.useContentLongerThan) {
          const len = parseInt(this.filter.contentMinLength);
          retval = course.siteHeadlineHtml.length >= len;
          if (!retval) return false;
        }

        if (this.filter.usePriceLongerThan) {
          const len = parseInt(this.filter.priceMinLength);
          retval = course.price.length >= len;
          if (!retval) return false;
        }

        return retval;
      
    },
    chkSearchEmptyChange() {
      this.filter.searchEmpty = !this.filter.searchEmpty;
      if (this.filter.searchEmpty) {
        this.filter.useContentLongerThan = false;
      }
    },
    chkUseContentLongerThanChange() {
      this.filter.useContentLongerThan = !this.filter.useContentLongerThan;
      if (this.filter.useContentLongerThan) {
        this.filter.searchEmpty = false;
      }
    },
  },
};
</script>
